module.exports = __webpack_public_path__ + "static/media/room-1.e928a5c4.jpeg";